
/**
 * VelaVora - Shop Login Button Color
 *
 * Customizes Shopify's Shop login button inside open Shadow DOM.
 * Includes default, hover, active, disabled and loading states.
 *
 * Visual customization only. Authentication is not modified.
 * Unofficial override; Shopify may change its internal markup.
 */

(() => {
  'use strict';

  if (window.__vvShopLoginColorInit) return;
  window.__vvShopLoginColorInit = true;

  const STYLE_ID = 'velavora-shop-login-style';

  const SELECTOR = [
    '[data-testid="login-button-container"] button',
    'button[data-testid="login-button"]'
  ].join(', ');

  const CSS = `
    /* Default Shop login button */
    button[data-testid="login-button"] {
    background-color: #D4A5B0 !important;
    }

     /* Hover state */
    button[data-testid="login-button"]:hover:not(:disabled):not([aria-busy="true"]) {
    background-color: #BE8D9B !important;
    }

    /* Active and disabled states */
    button[data-testid="login-button"]:active,
    button[data-testid="login-button"]:disabled,
    button[data-testid="login-button"][aria-busy="true"] {
    background-color: #D4A5B0 !important;
    }

    /* Shopify login loading overlay */
    [data-testid="shop-login-spinner"] {
    background-color: #D4A5B0 !important;
    }
    `;


  let pendingTimers = [];

  /**
   * Inject the brand stylesheet into accessible Shadow Roots.
   */
  function injectStyles(root = document) {
    if (
      root instanceof ShadowRoot &&
      root.querySelector(SELECTOR)
    ) {
      if (!root.getElementById(STYLE_ID)) {
        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = CSS;
        root.appendChild(style);
      }
    }

    root.querySelectorAll?.('*').forEach((element) => {
      if (element.shadowRoot) {
        injectStyles(element.shadowRoot);
      }
    });
  }

  /**
   * Handle asynchronous Shopify rendering.
   * Retry briefly after account interactions.
   */
  function scheduleInjection() {
    pendingTimers.forEach(clearTimeout);
    pendingTimers = [];

    injectStyles();

    const delays = [100, 300, 700, 1500, 3000];

    pendingTimers = delays.map((delay) =>
      setTimeout(() => {
        injectStyles();
      }, delay)
    );
  }

  /**
   * Detect account interactions without changing behavior.
   */
  function isAccountInteraction(event) {
    return event.composedPath().some((node) => {
      if (!(node instanceof Element)) return false;

      return (
        node.localName === 'shopify-account' ||
        node.matches?.(
          '[data-testid="login-button-container"], ' +
          '[data-testid="login-button"]'
        )
      );
    });
  }

  function initialize() {
    scheduleInjection();

    document
      .querySelectorAll('shopify-account')
      .forEach((account) => {
        account.addEventListener(
          'open',
          scheduleInjection
        );
      });

    document.addEventListener(
      'click',
      (event) => {
        if (isAccountInteraction(event)) {
          scheduleInjection();
        }
      },
      true
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (
          (event.key === 'Enter' || event.key === ' ') &&
          isAccountInteraction(event)
        ) {
          scheduleInjection();
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
